import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, SparklesIcon } from 'lucide-react';
export function Hero() {
  const scrollToProducts = () => {
    const element = document.getElementById('programas');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center pb-12 px-4 overflow-hidden pt-[50px]" data-id="element-23">
      {/* Background soft elements */}
      <div className="absolute top-0 left-0 w-full h-full -z-10 opacity-40" data-id="element-24">
        <div className="absolute top-[-10%] right-[-5%] w-[40%] h-[40%] bg-lavender rounded-full blur-[120px]" data-id="element-25" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[30%] h-[30%] bg-beige rounded-full blur-[100px]" data-id="element-26" />
      </div>

      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left space-y-8" data-id="element-28">
          <div className="space-y-4" data-id="element-29">
            <motion.span initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2
          }} className="inline-block text-gold-muted tracking-[0.2em] uppercase text-sm font-medium" data-id="element-30">
              Bienvenida al
            </motion.span>
            <h1 className="text-5xl md:text-7xl font-bold leading-tight text-text-dark" data-id="element-31">
              Portal <br data-id="element-32" />
              <span className="italic text-[#4A3B6B]" data-id="element-33">Terapéutico</span>
            </h1>
            <p className="text-xl md:text-2xl text-text-muted max-w-xl leading-relaxed font-light" data-id="element-34">
              Biblioteca digital de herramientas terapéuticas para acompañar
              procesos personales, energéticos y emocionales.
            </p>
          </div>

          <div className="space-y-6" data-id="element-35">
            <p className="text-text-muted/80 text-lg" data-id="element-36">
              Elegí el programa que querés conocer y accedé a toda la
              información desde su página oficial.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-37">
              <motion.button onClick={scrollToProducts} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="relative btn-primary text-lg overflow-hidden group/btn bg-gradient-to-r from-[#4A3B6B] via-[#6B5A8E] to-[#4A3B6B] bg-[length:200%_auto] hover:bg-right transition-all duration-500 hover:shadow-[0_0_25px_rgba(74,59,107,0.4)]" data-id="element-38">
                <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/btn:animate-[shimmer_1.5s_infinite]" style={{
                skewX: '-20deg'
              }} data-id="element-39" />
                <span className="relative flex items-center gap-2" data-id="element-40">
                  <SparklesIcon className="w-5 h-5 text-gold animate-pulse" data-id="element-41" />
                  Ver programas disponibles
                </span>
              </motion.button>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="relative" data-id="element-42">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-43">
            <img src="https://cdn.magicpatterns.com/uploads/cKmNUzjAggW98sC1YDaSLe/baa958e3-02ca-4427-92d7-fe32f0fd795b.webp" alt="Portal Terapéutico Biblioteca" className="w-full h-auto object-cover" data-id="element-44" />
          </div>
          {/* Decorative frame */}
          <div className="absolute -top-4 -right-4 w-full h-full border border-gold/30 rounded-2xl -z-0" data-id="element-45" />
          <div className="absolute -bottom-4 -left-4 w-full h-full border border-gold/30 rounded-2xl -z-0" data-id="element-46" />
        </motion.div>
      </div>

      <motion.div animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} className="mt-16 cursor-pointer opacity-50 hover:opacity-100 transition-opacity" onClick={scrollToProducts} data-id="element-47">
        <ChevronDownIcon className="w-8 h-8 text-text-muted" data-id="element-48" />
      </motion.div>
    </section>;
}